// Loaders for the un-bundled runtime modules under public/assets/. These are
// served by the backend and imported at runtime via native dynamic import —
// NOT bundled by Vite (the /* @vite-ignore */ keeps Vite from resolving them).
// CheerpJ looks up its Java_* native methods by string name, so bundling/
// minifying these bridge modules would rename those methods and break the games.

export interface HighscoresApi {
  getAdapter(id: string): Promise<unknown>;
  installCapture(
    game: unknown,
    adapter: unknown,
  ): Promise<{ onFSCommand?: ((cmd: string, arg: string) => void) | null }>;
  reportScore(gameId: string, score: number): Promise<unknown>;
}

export interface YogApi {
  createYogBridge(opts: { wsBase: string; name?: string; token?: string }): unknown;
  installYogNavGuard(): void;
}

export interface TouchApi {
  initTouchControls(opts: {
    stage: HTMLElement;
    game: unknown;
    runtimeElement: () => HTMLElement | null;
  }): void;
}

let _hs: Promise<HighscoresApi> | null = null;
export function loadHighscores(): Promise<HighscoresApi> {
  if (!_hs) {
    const url = "/assets/highscores.js";
    _hs = import(/* @vite-ignore */ url) as Promise<HighscoresApi>;
  }
  return _hs;
}

let _yog: Promise<YogApi> | null = null;
export function loadYogNet(): Promise<YogApi> {
  if (!_yog) {
    const url = "/assets/yog-net.js";
    _yog = import(/* @vite-ignore */ url) as Promise<YogApi>;
  }
  return _yog;
}

let _touch: Promise<TouchApi> | null = null;
export function loadTouchControls(): Promise<TouchApi> {
  if (!_touch) {
    const url = "/assets/touch-controls.js";
    _touch = import(/* @vite-ignore */ url) as Promise<TouchApi>;
  }
  return _touch;
}
